import * as Yup from "yup";

export function getAuthInitialValues(obj) {
  return {
    otp: obj?.otp || "",
  };
}

const VALIDATION_SCHEMA = Yup.object().shape({
  otp: Yup.string().trim()
  .min(6, "6 digit required.")
  .required("Too Short!"),
});

export { VALIDATION_SCHEMA };
